import { KolumnaSpisuFiltrowanie } from './kolumnaSpisuFiltrowanie';

export class PobierzOswiadczeniaProjektuFiltry {
  kolumnyFiltrowania: Array<KolumnaSpisuFiltrowanie> = new Array();
  idProjektu: string;
}
